(function () {
	const setAnnouncementHeight = () => {
		const announcements = document.querySelectorAll(
			'.shopify-section-group-header-group.section-announcement'
		);

		let totalHeight = 0;
		announcements.forEach((announcement) => {
			totalHeight += announcement.offsetHeight;
		});

		document.documentElement.style.setProperty(
			'--announcement-height',
			`${totalHeight}px`
		);
	};

	class AnnouncementBar extends HTMLElement {
		connectedCallback() {
			this.section = this.closest('.section-announcement');
			this.dismissKey = `announcement-bar-dismissed-${this.dataset.sectionId}`;

			if (this.isDismissed()) {
				if (this.section) this.section.style.display = 'none';
				setAnnouncementHeight();
				return;
			}

			const closeBtn = this.querySelector('.announcement-bar__close');
			if (closeBtn) {
				closeBtn.addEventListener('click', () => this.dismiss());
			}

			this.initSlider();
			setAnnouncementHeight();
		}

		disconnectedCallback() {
			if (this.slider) {
				this.slider.destroy(true, true);
				this.slider = null;
			}
		}

		isDismissed() {
			// Always visible in the theme editor
			if (window.Shopify && window.Shopify.designMode) return false;
			try {
				return sessionStorage.getItem(this.dismissKey) === '1';
			} catch (e) {
				return false;
			}
		}

		dismiss() {
			try {
				sessionStorage.setItem(this.dismissKey, '1');
			} catch (e) {
				// sessionStorage unavailable — dismissal just won't persist
			}
			if (this.section) this.section.style.display = 'none';
			setAnnouncementHeight();
		}

		initSlider() {
			const container = this.querySelector('.announcement-bar__slider');
			if (!container || typeof Swiper === 'undefined') return;

			const slides = container.querySelectorAll('.announcement-bar__slide');
			if (slides.length < 2) return;

			const effect = this.dataset.effect || 'slide-up';
			const delay = parseInt(this.dataset.speed, 10) || 5000;
			const autoplay = this.dataset.autoplay === 'true';
			const reducedMotion = window.matchMedia(
				'(prefers-reduced-motion: reduce)'
			).matches;

			const config = {
				loop: true,
				speed: 500,
				slidesPerView: 1,
				// Vertical touch-drag would fight page scroll on mobile
				allowTouchMove: effect !== 'slide-up',
				autoplay:
					autoplay && !reducedMotion
						? {
								delay: delay,
								pauseOnMouseEnter: true,
								disableOnInteraction: false,
							}
						: false,
			};

			if (effect === 'slide-up') config.direction = 'vertical';
			if (effect === 'fade') {
				config.effect = 'fade';
				config.fadeEffect = { crossFade: true };
			}

			const prevEl = this.querySelector('.announcement-bar__nav--prev');
			const nextEl = this.querySelector('.announcement-bar__nav--next');
			if (prevEl && nextEl) {
				config.navigation = { prevEl: prevEl, nextEl: nextEl };
			}

			this.slider = new Swiper(container, config);
		}
	}

	if (!customElements.get('announcement-bar')) {
		customElements.define('announcement-bar', AnnouncementBar);
	}

	setAnnouncementHeight();
	window.addEventListener('resize', setAnnouncementHeight);
	document.addEventListener('shopify:section:load', setAnnouncementHeight);

	if (window.Shopify && window.Shopify.designMode) {
		document.addEventListener('shopify:block:select', (event) => {
			const bar = event.target.closest('announcement-bar');
			if (!bar || !bar.slider) return;
			const slide = event.target.closest('.announcement-bar__slide');
			if (!slide) return;
			bar.slider.slideToLoop(parseInt(slide.dataset.index, 10) || 0);
			if (bar.slider.autoplay) bar.slider.autoplay.stop();
		});

		document.addEventListener('shopify:block:deselect', (event) => {
			const bar = event.target.closest('announcement-bar');
			if (!bar || !bar.slider || !bar.slider.autoplay) return;
			if (bar.dataset.autoplay === 'true') bar.slider.autoplay.start();
		});
	}
})();
